export default "__VITE_ASSET__1bd35edf__"